/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
import React from 'react';
import { LazyLink } from '../../../../../../slices/atoms/index.js';
import { LogoContainer } from './BrandStyles.js';

const Brand = navigation => {
  const { navigation_image } = navigation;

  return (
    <LogoContainer renderAs={LazyLink} url="https://www.digitalocean.com">
      <img src={navigation_image.url} alt="DigitalOcean logo" />
    </LogoContainer>
  );
};

export default Brand;
